import React from 'react'
import { PAGE_URL } from 'utils'
import AllServicesIcon from 'static/icons/all-services.svg'
import CalendarOff from 'static/icons/calendar-off.svg'
import UserCircleOutline from 'static/icons/user-circle-outline.svg'
import PawOutline from 'static/icons/paw-outline.svg'
import CreditCardOutline from 'static/icons/credit-card-outline.svg'
import ShoppingBag from 'static/icons/shopping-bag.svg'
// import CheckCircleOutline from 'static/icons/check-circle-outline.svg'

export const TABS = [
  {
    title: 'Serviços',
    href: `${PAGE_URL.SCHEDULING_INDEX}?tab=servicos`,
    icon: <AllServicesIcon />,
    showOnMobile: true
  },
  {
    title: 'Minha agenda',
    href: `${PAGE_URL.SCHEDULING_INDEX}?tab=agenda`,
    icon: <CalendarOff />,
    showOnMobile: true
  },
  {
    title: 'Meus dados',
    icon: <UserCircleOutline />,
    href: PAGE_URL.USER_PROFILE,
    menuTitle: 'Meus dados',
    onlyLogged: true
  },
  {
    title: 'Meus pets',
    icon: <PawOutline />,
    href: PAGE_URL.USER_PETS,
    onlyLogged: true
  },
  {
    title: 'Meus Cartões',
    icon: <CreditCardOutline />,
    href: PAGE_URL.USER_CREDIT_CARDS,
    onlyLogged: true
  },
  {
    title: 'Explore a Cobasi',
    icon: <ShoppingBag />,
    href: 'https://www.cobasi.com.br',
    menuOnly: true,
    hideOnApp: true
  }
  // {
  //   title: 'Permissões',
  //   icon: <CheckCircleOutline />,
  //   href: PAGE_URL.PERMISSIONS
  // }
]

export const DEFAULT_HOME_CURRENT_PATH = `${PAGE_URL.SCHEDULING_INDEX}?tab=servicos`
